import ApiService from "@/core/services/api.service";

export const setStep = (payload) => {
  return ApiService.post(`students/step`, payload);
};

export default {
  setStep,
};
